import React, { useEffect } from "react";
import TaskContent from "../TaskContent";
import TaskFooter from "../TaskFooter";
import TaskHeader from "../TaskHeader";
import { useTimelineContext } from "store/contexts/timelineContext";

export default ({ listTask }) => {
  const { selectTodoListItem, selectlistTask } = useTimelineContext();

  useEffect(() => {
    if (!selectlistTask) return;
    selectTodoListItem(listTask);

    //eslint-disable-next-line
  }, [listTask]);

  return (
    <div className="tasks-post">
      <div className="posts_data mb-30 simple-text p-3">
        <TaskHeader listTask={listTask} />
        <TaskContent listTask={listTask} />
        <TaskFooter listTask={listTask} />
      </div>
    </div>
  );
};
